// extracted by mini-css-extract-plugin
export default {"rowHeading":"styles_rowHeading__KW6Td"};